import { useCallback } from 'react'
import api, { APIResponse } from '../../lib/commons/api'
import {
  FetchProjectCloseParams,
  fetchTaskActualWorkApprovalStatusInfoParams,
  ProjectCloseRequestInput,
  TaskActualWorkApprovalRepository,
} from '../../applications/ports/taskActualWorkApprovalRepository'

export const useTaskActualWorkApprovalRepository =
  (): TaskActualWorkApprovalRepository => {
    const closeProjectToTaskActualWorkApprovalStatus = useCallback(
      async (request: ProjectCloseRequestInput): Promise<APIResponse> => {
        return api.functional.request(
          'POST',
          '/api/v1/projects/task_actual_work_approval/close',
          request
        )
      },
      []
    )

    const cancelCloseProjectToTaskActualWorkApprovalStatus = useCallback(
      async (request: ProjectCloseRequestInput): Promise<APIResponse> => {
        return api.functional.request(
          'POST',
          '/api/v1/projects/task_actual_work_approval/cancel',
          request
        )
      },
      []
    )

    const fetchTaskActualWorkProjectClosing = useCallback(
      async (params: FetchProjectCloseParams): Promise<APIResponse> => {
        return api.functional.request(
          'GET',
          '/api/v1/projects/task_actual_work_approval',
          params
        )
      },
      []
    )

    const fetchTaskActualWorkApprovalStatusInfo = useCallback(
      async (
        params: fetchTaskActualWorkApprovalStatusInfoParams
      ): Promise<APIResponse> => {
        return api.functional.request(
          'GET',
          '/api/v1/actual_working_hours/user/task_actual_work',
          params
        )
      },
      []
    )

    return {
      closeProjectToTaskActualWorkApprovalStatus,
      cancelCloseProjectToTaskActualWorkApprovalStatus,
      fetchTaskActualWorkProjectClosing,
      fetchTaskActualWorkApprovalStatusInfo,
    }
  }
